<div
  class="flex min-h-[calc(100vh-120px)] w-full flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-4"
>
  <h1
    class="text-4xl sm:text-5xl font-extrabold tracking-wide text-gray-800 dark:text-white"
  >
    ACCESS DENIED
  </h1>

  <!-- 4 [lock] 3 -->
  <div class="mt-8 flex items-center gap-6">
    <span
      class="text-[110px] sm:text-[140px] font-extrabold leading-none text-indigo-500 select-none"
      >4</span
    >

    <div
      class="flex h-28 w-28 sm:h-36 sm:w-36 items-center justify-center rounded-3xl border-2 border-indigo-400 bg-white dark:bg-gray-800"
    >
      <svg
        class="h-14 w-14 sm:h-16 sm:w-16 text-indigo-500"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="4" y="10" width="16" height="10" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        <circle cx="12" cy="15" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    </div>

    <span
      class="text-[110px] sm:text-[140px] font-extrabold leading-none text-indigo-500 select-none"
      >3</span
    >
  </div>

  <p
    class="mt-8 text-sm sm:text-base text-gray-600 dark:text-gray-400 text-center max-w-md"
  >
    You don't have permission to access this page. Please contact your
    administrator if you believe this is a mistake.
  </p>

  <button
    type="button"
    (click)="goHome()"
    class="mt-6 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 shadow-sm transition hover:bg-gray-100 dark:hover:bg-gray-700"
  >
    Back to Home Page
  </button>
</div>
